import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import {
  getChannels,
  getTickerSeriesList,
  getPlaylistsV2,
  getPlaylistPreloadStateV2,
  isFetchingPlaylistV2,
} from "../../selectors";
import ContentModalPlaylistPreviewLink from "../ContentModalPlaylistPreviewLink ";
import { callOnEnter } from "../../utils/eventHelpers";
import Box from "../layout/Box";
import ChannelPreviewLink from "../ChannelPreviewLink";
import Switch from "../widgets/Switch";
import "./styles.scss";
import { getProfile } from "../../selectors/profile";
import { OrientationSelectWidget } from "signoxe/components/widgets/OrientationSelectWidget";
import PlaylistCondition from "../PlaylistCondition";
import TagsMatchingCondition from "../TagsMatchingCondition";

import { TICKERS_RESOURCE } from "signoxe/api/resources";
import SelectSearch from "../widgets/SelectSearch";

const ContentFeedView = ({
  deviceGroup,
  feed,
  channelOptions,
  playlistOptions,
  tickerSeriesOptions,
  nextPlaylists,
  isLoadingPlaylist,
  onChange,
  profile,
  hideDurations,
  hideOrientationSelection,
  hideOverlayTickers,
  first,
  handleUserReport,
  deviceTags=[],
  onDeviceGroupChange,
}) => {
  console.log("nextPlaylists", nextPlaylists)
  console.log("playlistOptions", playlistOptions)
  const handleChange = (selectedValue, field) =>{
    onChange(feed.id, {
      [field]: field.includes("duration")
        ? selectedValue.value * 1000
        : selectedValue.value,
    });


  }

  const isTagsMaching = profile && profile.tags_matching 
  const isCPEnabled = profile && profile.features && profile.features.conditional_playback 

  console.log("is there a next", nextPlaylists && nextPlaylists.length)

  const handleChangePlay = (selectedValue) => {
    onChange(feed.id, { ['media_playlist']: selectedValue.value });
  }

  const multiRegionEnabled =
    profile &&
    profile.features &&
    profile.features.multiregion &&
    localStorage.getItem("multiregion_switch") == "true";


  // media playlist options
  var mediaPlaylist_Options
  var default_mediaPlaylist = {label:"-- Choose -- ", value:''}
  deviceGroup != undefined?
    deviceGroup.conditional_playback_switch == true ? mediaPlaylist_Options = [{label:"----------", value:''}] :
    mediaPlaylist_Options = [{label:"-- Choose -- ", value:''}]
  : mediaPlaylist_Options = []

  playlistOptions?
    playlistOptions.map((option, index) => {
      mediaPlaylist_Options.push({label:option.name, value:option.id})
      if(feed.media_playlist == option.id){
        default_mediaPlaylist = {label:option.name, value:option.id}
      } 
    })
  : ()=>{
    mediaPlaylist_Options = {label:'add playlists to get options', value:''}
    default_mediaPlaylist = {label:'add playlists to get options', value:''}
  } 


  // ticker series options
  var tickerSeries_Options
  var default_tickerSeries = {label:"-- Choose -- ", value:''}
  deviceGroup != undefined?
    deviceGroup.conditional_playback_switch == true ? tickerSeries_Options = [{label:"----------", value:''}] :
    tickerSeries_Options = [{label:"-- Choose -- ", value:''}]
  : tickerSeries_Options = []

  tickerSeriesOptions?
    tickerSeriesOptions.map((option, index) => {
      tickerSeries_Options.push({label:option.name, value:option.id})
      if(feed.ticker_series == option.id){
        default_tickerSeries = {label:option.name, value:option.id}
      } 
    })
  : ()=>{
    tickerSeries_Options = {label:'add stickers to get options', value:''}
    default_tickerSeries = {label:'add stickers to get options', value:''}
  }



  // channel options
  var channel_Options = [{label:"-- Choose -- ", value:''}]
  var default_channel = {label:"-- Choose -- ", value:''}

  channelOptions?
    channelOptions.map((option, index) => {
      channel_Options.push({label:option.name, value:option.id})
      if(feed.channel == option.id){
        default_channel = { label:option.name, value:option.id }
      } 
    })
  : ()=>{
    channel_Options = {label:'add Channel to get options', value:''}
    default_channel = {label:'add Channel to get options', value:''}
  } 

  

  if (!multiRegionEnabled) {
    return (
      <Box
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        className="content-feed-view  wrap-for-small"
      >
        <Box
          className="playlist-ticker " direction="row" alignItems="center">
          <Box direction="column" className="playlist-ticker-mobile">
            <label for="playlist">Select Playlist</label>
            <SelectSearch 
              loading={nextPlaylists && nextPlaylists.length != null}
              placeHolder={default_mediaPlaylist || "Select a playlist"}  
              options={mediaPlaylist_Options} 
              style={{width:`7rem`, backgroundColor:'white'}}
              onSelect={
                  (options)=>{
                    console.log(feed)
                    handleChangePlay(options)
                  }
              }
              name={'Select Playlist'}
              id={'SelectPlaylist'}
              multiple={false}
            />
          </Box>
          <Box className="tickerSeries-box playlist-ticker-mobile " direction="column">
            <label for="tickerSeries">Select TickerSeries</label>
            <SelectSearch 
              placeHolder={default_tickerSeries || ""}  
              options={tickerSeries_Options} 
              style={{width:`7rem`, backgroundColor:'white'}}
              onSelect={
                  (selectedValue)=>{
                    console.log(feed)
                    handleChange(selectedValue, 'ticker_series')
                  }
              }
              name={'ticker Series'}
              id={'tickerSeries'}
              multiple={false}
            />
          </Box>
          {
            deviceGroup != undefined?
              deviceGroup.conditional_playback_switch ? (
              <>
               { !isTagsMaching &&
                <PlaylistCondition
                  label="Set Conditions"
                  feed={feed}
                  first={first}
                  icon={true}
                  deviceTags={deviceTags}
                  onDeviceGroupChange={onDeviceGroupChange}
                  deviceGroup={deviceGroup}
                />}
              </>
              ) : (
               <>
               {!isTagsMaching &&
                 <ContentModalPlaylistPreviewLink
                 playlist={feed.media_playlist}
                 ticker={feed.ticker_series}
                 label="Preview"
                 icon={true}
               />
               }
               </>
              )
            : null
          }

            {isTagsMaching && !isCPEnabled &&
            <TagsMatchingCondition
                label="Tags Matching"
                feed={feed}
                first={first}
                icon={true}
                deviceTags={deviceTags}
                onDeviceGroupChange={onDeviceGroupChange}
                deviceGroup={deviceGroup}
            />
            }
        </Box>
      </Box>
    );
  } else {
    return (
      <Box
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        className="content-feed-view  wrap-for-small"
      >
        <Box
          className="device-group-channel"
          direction="column"
          alignItems="center"
        >
          <label for="channel-select">Select Channel</label>
          <SelectSearch 
            placeHolder={default_channel || ""}  
            options={channel_Options} 
            style={{width:`12rem`, backgroundColor:'white'}}
            onSelect={
              (selectedValue)=>{
                console.log(feed)
                handleChange(selectedValue, 'channel')
              }
            }
            name={'channel Select'}
            id={'channelSelect'}
            multiple={false}
          />
        </Box>
      </Box>
    );
  }
};

ContentFeedView.propTypes = {
  feed: PropTypes.shape({
    image_duration: PropTypes.number.isRequired,
    web_duration: PropTypes.number.isRequired,
    channel: PropTypes.number,
    ticker_series: PropTypes.number,
    overlay_ticker: PropTypes.bool.isRequired,
  }),
  profile: PropTypes.shape({
    username: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    activation_date: PropTypes.string.isRequired,
    renewal_date: PropTypes.string.isRequired,
    next_renewal_date: PropTypes.string.isRequired,
    profile: PropTypes.shape({
      name: PropTypes.string.isRequired,
      organisation_name: PropTypes.string.isRequired,
      organisation_address: PropTypes.string.isRequired,
      primary_contact_name: PropTypes.string.isRequired,
      primary_contact_phone: PropTypes.string.isRequired,
      primary_contact_email: PropTypes.string.isRequired,
      financial_contact_name: PropTypes.string.isRequired,
      financial_contact_email: PropTypes.string.isRequired,
      financial_contact_phone: PropTypes.string.isRequired,
      technical_contact_name: PropTypes.string.isRequired,
      technical_contact_email: PropTypes.string.isRequired,
      technical_contact_phone: PropTypes.string.isRequired,
    }).isRequired,
  }),
  onChange: PropTypes.func.isRequired,
};

export default connect((state) => ({
  channelOptions: getChannels(state),
  playlistOptions: getPlaylistsV2(state),
  nextPlaylists: getPlaylistPreloadStateV2(state),
  isLoadingPlaylist:isFetchingPlaylistV2(state),
  profile: getProfile(state),
  tickerSeriesOptions: getTickerSeriesList(state),
}))(ContentFeedView);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/ContentFeedView/index.js